import Swiper from "swiper/bundle";

const ServicesSlider = () => {
  const sliders = Array.from(document.querySelectorAll(".services-slider"));
  if (sliders.length > 0) {
    sliders.forEach((slider) => {
      const initSlider = new Swiper(slider, {
        spaceBetween: 16,
        slidesPerView: 1.1,
        lazy: {
          loadPrevNext: true,
        },
        breakpoints: {
          767: {
            slidesPerView: 1.9,
          },
          1023: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    });
  }
};

export default ServicesSlider;
